<!-- Diff from Angular collaborator.component:
     - Title: "New Chat" instead of "Collaborators"
     - App bar right: addUser icon (opens email input modal) + close, instead of just close
     - No owner row
     - Member tiles: avatar + name + email + checkbox, instead of name + email + role
     - No role menu
     - No FAB
     - Bottom: "START MESSAGING" button instead of Save/Close bar
     - Limit banner when 16 reached
-->
<div class="top-section">
    <h6 class="heading mb-0 text-18-500">{{ ss.t('collaborators_title') }}</h6>
    <div class="flex items-center gap-6">
        <app-svg name="topBarAddCollaborator" role="button" (click)="openAddCollaboratorInput()" class="icon-mirror-rtl"
            [color]="isLimitReached() ? ss.theme().color10 : ss.theme().color12"></app-svg>
        <app-svg name="topBarClose" role="button" (click)="close()"></app-svg>
    </div>
</div>

<!-- Limit reached banner (matches Flutter _LimitReachedBanner) -->
<div class="limit-banner" *ngIf="isLimitReached()">
    <app-svg name="info" [color]="ss.theme().color14" width="18" height="18"></app-svg>
    <span class="limit-text color-14">{{ ss.t('messages_memberLimitReached')
        }}</span>
</div>

<div class="body-section collab-block">
    <!-- Collaborator suggestion list with checkboxes (replaces owner + member tiles) -->
    <ng-container *ngFor="let email of collaboratorEmails()">
        <div class="collab-item flex items-center justify-between ri-p-4 cursor-pointer"
            (click)="toggleSelection(email)">
            <!-- Avatar (matches Flutter: MeUserAvatar radius:8 in 20x20 SizedBox) -->
            <div class="flex items-start gap-[10px]">
                <app-me-user-avatar [hashedEmail]="email" [radius]="9" [addBorder]="false"
                    [fallbackName]="getDisplayName(email)" class="collab-avatar"></app-me-user-avatar>
                <!-- Name + email -->
                <div class="collab-info flex flex-col gap-1">
                    <p class="text-16-400 color-8 mb-0 !leading-[14px]">{{ getDisplayName(email) }}</p>
                    <p class="text-12-400 color-7 mb-0" *ngIf="getDisplayName(email) !== email">{{ email }}</p>
                </div>
            </div>

            <!-- Checkbox (matches Flutter MeCheckBox: 18px square, 2px radius, color35 checked, color7 unchecked) -->
            <div class="message-checkbox" [class.message-checkbox--checked]="isSelected(email)">
                @if (isSelected(email)) {
                <app-svg name="tick" [color]="ss.theme().color12" width="14" height="14"></app-svg>
                }
            </div>
        </div>
    </ng-container>

    <!-- Inline email input — desktop only (>750px) -->
    <div class="inline-input-container desktop-only" *ngIf="isInputActive()">
        <div class="inline-input-wrapper">
            <div class="input-wrapper flex w-full">
                <input type="email" class="inline-email-input" dir="ltr" [placeholder]="ss.t('enterEmail_title')"
                    [(ngModel)]="emailInputValue" (keydown.enter)="addMemberFromInlineInput()" autocomplete="off"
                    #emailInput>

                <button class="inline-add-btn" (click)="addMemberFromInlineInput()">
                    <app-svg name="plus" [color]="emailInputValue ? ss.theme().color35 : ss.theme().color10" width="12"
                        height="12"></app-svg>
                </button>
            </div>

        </div>
    </div>

    <!-- Empty state when no collaborators -->
    <div class="empty-state h-full" *ngIf="collaboratorEmails().length === 0 && !isLoading()">
        <app-no-result-block [imagePlaceholder]="'emptyCollaboratorPageState'"
            [message]="ss.t('collaborators_emptyScreenContent')" [showQuickGuide]="false">
        </app-no-result-block>
    </div>

    <!-- Extra bottom space -->
    <div class="extra-block"></div>
</div>

<!-- "START MESSAGING" button (replaces Save/Close bottom bar) -->
<div class="bottom-bar" *ngIf="selectedEmails().length > 0">
    <button class="btn start-messaging-btn text-16-400" (click)="startMessaging()">
        {{ ss.t('messages_startMessaging') }}
    </button>
</div>